
import { FdmPlugin, FdmPluginInterface } from './plugins';

import * as _ from 'lodash';
import { XsPropsible } from '@src/app/xs/utilities/propsible.class';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { MapService } from '../map.service';

const Cesium = (<any>window).Cesium;


export class LabelsHandler extends FdmPlugin implements FdmPluginInterface {



    // required name identifier
    static meta = {
        label: 'PLUGINS.LABELS_HANDLER.LABEL',
        name: 'labels-handler',
        translator: 'PLUGINS.LABELS_HANDLER',
        tooltip: 'PLUGINS.LABELS_HANDLER.TOOLTIP',
        hideHeader:true,
        hideWrapper:true,
        category: FdmPlugin.category.generic,
        cardinality: FdmPlugin.cardinality.one
    };

    properties:string[] = ['none'];

    // our controls
    controls:any = {

        active: { type:'check', value:false, name: this.meta.translator+'.ACTIVE' },

        info: { type:'info', name: this.meta.translator+'.INFO', value:this.meta.translator+'.INFO_VALUE', translateValue:true, translateParams:{viewLength:0,possibleLength:0} },
        labelProperty:  { type:'select', name: this.meta.translator+'.LABELPROPERTY', value: '', propType:'string', options: this.properties, translateOptions:true },
        labelColor:      { type:'color', name: this.meta.translator+'.LABELCOLOR', value:'#fff' },
        labelSize:      { type:'slider', name: this.meta.translator+'.LABELSIZE', value:12, min:6, max:20, step:1 },

        distanceDisplayCondition: { type:'check', name:this.meta.translator+'.DISTANCEDISPLAYCONDITION', group:'advanced' },
        distanceDisplayConditionRange: { type:'range', name:this.meta.translator+'.DISTANCEDISPLAYCONDITIONRANGE', value:'0,10000', min:0, max:10000, from:0, to:10000, noshow:true, group:'advanced'  },
        
        translucencyByDistance: { type:'check', name:this.meta.translator+'.TRANSLUCENCYBYDISTANCE', group:'advanced' },
        translucencyByDistanceRange: { type:'range', name:this.meta.translator+'.TRANSLUCENCYBYDISTANCERANGE', value:'0,10000', min:0, max:10000, from:0, to:10000, noshow:true, group:'advanced'  },
        translucencyByDistanceRangeOpacityFrom: { type:'slider', name:this.meta.translator+'.TRANSLUCENCYBYDISTANCERANGEOPACITYFROM', value:0.5, min:0, max:1, step:0.1, noshow:true, group:'advanced'  },
        translucencyByDistanceRangeOpacityTo: { type:'slider', name:this.meta.translator+'.TRANSLUCENCYBYDISTANCERANGEOPACITYTO', value:0.9, min:0, max:1, step:0.1, noshow:true, group:'advanced'  },

        scaleByDistance: { type:'check', name:this.meta.translator+'.SCALEBYDISTANCE', group:'advanced' },
        scaleByDistanceRange: { type:'range', name:this.meta.translator+'.SCALEBYDISTANCERANGE', value:'0,10000', min:0, max:10000, from:0, to:10000, noshow:true, group:'advanced'  },
        scaleByDistanceRangeScaleFrom: { type:'slider', name:this.meta.translator+'.SCALEBYDISTANCERANGESCALEFROM', value:0.5, min:0.1, max:10, step:0.1, noshow:true, group:'advanced'  },
        scaleByDistanceRangeScaleTo: { type:'slider', name:this.meta.translator+'.SCALEBYDISTANCERANGESCALETO', value:1.5, min:0.0, max:10, step:0.1, noshow:true, group:'advanced'  },

        // labelOffset:     { type:'slider', name: 'Offset', value:0, min:-10000, max:10000, step:1 },
        labelBackground: { type:'check', name: this.meta.translator+'.LABELBACKGROUND', value:true, group:'back' },
        labelBackgroundColor:      { type:'color', name: this.meta.translator+'.LABELBACKGROUNDCOLOR', value:'#00000088', group:'back' },
        labelPadding:   { type:'slider', name:this.meta.translator+'.LABELPADDING', value:5, min:1, max:10, step:1, noshow: true, group:'back' },

        coordType:      { type:'select', name: this.meta.translator+'.COORDTYPE', value:'cartographic_degrees', options: [ 'cartographic_degrees','cartographic_radians','cartesian' ], translateOptions:true, group:'coord' },
        coordPropertyX: { type:'select', name: this.meta.translator+'.COORDPROPERTYX', value: 'longitude', propType:'string', options: this.properties, translateOptions:true, group:'coord' },
        coordPropertyY: { type:'select', name: this.meta.translator+'.COORDPROPERTYY', value: 'latitude', propType:'string', options: this.properties, translateOptions:true, group:'coord' },
        coordPropertyZ: { type:'select', name: this.meta.translator+'.COORDPROPERTYZ', value: 'height', propType:'string', options: this.properties, translateOptions:true, group:'coord' },
    }


    // resetting the eye-offset every once in a while ...
    pulseSeconds = 5;

    // quick checks for visual state
    bigPulseSeconds = 0.5;

    // our color / range configuration
    config:any = null;

    // label entities
    labelEntities:any = null;

    propertyStore:XsPropsible = new XsPropsible();

    itemShowState:boolean = true;
    _itemShowState:boolean = true;

    // support for 3DTileset properties
    ___tilesLoadingEnd() {

        // more tiles have finished loading, so check if there's more properties
        XsAwait.until(['propertyStore','item.__properties'], this ).then ( _ => {

            this.propertyStore.populate( this.item['__properties'] );
            this.controls.labelProperty.options = this.propertyStore.getPropertyNames();
            this.controls.coordPropertyX.options = this.propertyStore.getPropertyNames();
            this.controls.coordPropertyY.options = this.propertyStore.getPropertyNames();
            this.controls.coordPropertyZ.options = this.propertyStore.getPropertyNames();

            // console.log('@@LABELS props', this.item['__properties'], this.propertyStore); 

            this.refresh();
        });
    }

    init() {

        let me = this;

        // base label type
        this.addEntityType ( 'label', {
            show: true,
            position: null,
            label: {
                text: 'test',
                font : '12px sans-serif',
                showBackground:true,
                fillColor: Cesium.Color.WHITE,
                backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                backgroundPadding: new Cesium.Cartesian2(8,2),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                eyeOffset : new Cesium.Cartesian3(0, 0, -10000),
            },
        });

        // half-time fetch some data to get going (support for 3DTileset properties slowly loading over time)
        setTimeout ( () => { me.___tilesLoadingEnd(); }, 2000 );

        this.startPulse();
        this.startBigPulse();
    }

    saveBefore() {
        this.controls.distanceDisplayConditionRange.value = this.controls.distanceDisplayConditionRange.from + ',' + this.controls.distanceDisplayConditionRange.to;
        this.controls.translucencyByDistanceRange.value = this.controls.translucencyByDistanceRange.from + ',' + this.controls.translucencyByDistanceRange.to;
        this.controls.scaleByDistanceRange.value = this.controls.scaleByDistanceRange.from + ',' + this.controls.scaleByDistanceRange.to;
    }

    loadAfter() {
        let s1 = (''+this.controls.distanceDisplayConditionRange.value).split(',');
        if ( s1[1] ) {
            this.controls.distanceDisplayConditionRange.from = s1[0];
            this.controls.distanceDisplayConditionRange.to = s1[1];
        }
        let s2 = (''+this.controls.translucencyByDistanceRange.value).split(',');
        if ( s2[1] ) {
            this.controls.translucencyByDistanceRange.from = s2[0];
            this.controls.translucencyByDistanceRange.to = s2[1];
        }
        let s3 = (''+this.controls.scaleByDistanceRange.value).split(',');
        if ( s3[1] ) {
            this.controls.scaleByDistanceRange.from = s3[0];
            this.controls.scaleByDistanceRange.to = s3[1];
        }
    }

    pulse() {
        if ( this.controls.active.value ) {
            if ( this.labelEntities && this.labelEntities.length && this.services.mapService && this.services.mapService.cameralocation ) {
                let h = Math.floor(this.services.mapService.cameralocation.height);
                let c = Math.floor(((h+1) / 200)) + 1;
                this.labelEntities.forEach ( e => {
                    if ( e && e.label ) {
                        e.label.eyeOffset = new Cesium.Cartesian3(0, 0, -c);
                    }
                });
                // console.log('!!eyeOffset', h, c, -c );
            }  
        }
    }

    bigPulse() {
        if ( this.controls.active.value ) {
            if ( this.labelEntities && this.labelEntities.length && this.services.mapService && this.services.mapService.scene ) {
                this.itemShowState = this.services.mapService.scene['layerProps'][MapService.VIEW + this.item.id] ? true : false;
                if ( this.itemShowState !== this._itemShowState ) {
                    this._itemShowState = this.itemShowState;
                    this.setLabelsView(this.itemShowState);
                }
            }
        }
    }

    setLabelsView( state:boolean = true ) {
        this.labelEntities.forEach ( e => {
            if ( e ) {
                e.show = state;
            }
        });
    }

    updateAllPropertyLists ( propertyList:any[] = null ) {
        let props = this.properties;
        if ( propertyList ) {
            props = propertyList;
        }
        Object.keys(this.controls).forEach ( key => {
            let c = this.controls[key];
            if ( c.propType ) {
                c.options = props;
            }
        });
    }

    valuesInjected ( config:any = null ) {

        // console.log('@@LABELS valuesInjected()', config, this.propertyStore );

        if ( !this.controls.active.value ) {
            return;
        }

        this.config = config;

        // our input API

        // config.attributes is a list of properties
        if ( config.attributes ) {

            // update all controls that has a list of properties
            this.properties = config.attributes;
            this.updateAllPropertyLists();
        }

        this.refresh();
    }

    xx:number = 0;


    refresh( newvalue = null, section:any = null ) {

        this.xx = 0;

        // check in with mama
        super.refresh ( newvalue, section );

        // clear old labels
        this.wipe();

        if ( !this.controls.active.value ) {
            this.turnOffAllBut ( 'active' );
            return;
        } else {
            this.turnOnAllBut ( 'active' );
        }

        this.labelEntities = [];

        let props = [ this.controls.labelProperty.value, this.controls.coordPropertyX.value, this.controls.coordPropertyY.value ];

        if ( this.controls.coordType.value == 'cartographic_degrees' ) {
            this.controls.coordPropertyX.label = 'Longitude';
            this.controls.coordPropertyY.label = 'Latitude';
            this.controls.coordPropertyZ.label = 'Height';
        } else if ( this.controls.coordType.value == 'cartographic_radians' ) {
            this.controls.coordPropertyX.label = 'Longitude';
            this.controls.coordPropertyY.label = 'Latitude';
            this.controls.coordPropertyZ.label = 'Height';
        } else if ( this.controls.coordType.value == 'cartesian' ) {
            props = [ this.controls.labelProperty.value, this.controls.coordPropertyX.value, this.controls.coordPropertyY.value, this.controls.coordPropertyZ.value ];
            this.controls.coordPropertyX.label = 'X';
            this.controls.coordPropertyY.label = 'Y';
            this.controls.coordPropertyZ.label = 'Z';
        }

        this.noshowControl ( 'labelBackground', ['labelPadding'] );

        this.noshowControl ( 'distanceDisplayCondition', ['distanceDisplayConditionRange'] );

        this.noshowControl ( 'translucencyByDistance', ['translucencyByDistanceRange','translucencyByDistanceRangeOpacityFrom','translucencyByDistanceRangeOpacityTo'] );

        this.noshowControl ( 'scaleByDistance', ['scaleByDistanceRange','scaleByDistanceRangeScaleFrom','scaleByDistanceRangeScaleTo'] );


        const result = this.findAllProps ( this.propertyStore, props );
        
        if ( result && result.length ) {

            result.forEach ( item => {

                this.xx++;

                let e = null;
                let config = this.getEntityType ( 'label', {} );
                let cartesianPosition = Cesium.Cartesian3.fromDegrees( item[props[2]], item[props[1]], props[3] ? item[props[3]] : 1000 );
                if ( cartesianPosition ) {
                    
                    // console.log('$$$$$$$', config, item, cartesianPosition );
                    if ( config && config['label'] ) {

                        config.position = cartesianPosition;

                        config.label.text = item[props[0]];
                        config.label.fillColor = Cesium.Color.fromCssColorString(this.controls.labelColor.value);
                        config.label.font = this.controls.labelSize.value + 'px sans-serif';
    
                        config.label.showBackground = this.controls.labelBackground.value;
                        
                        if ( this.controls.labelBackground.value ) {
                            let value = this.controls.labelPadding.value;
                            config.label.backgroundPadding = new Cesium.Cartesian2(value*1.2,value*0.8);
                            config.label.style = Cesium.LabelStyle.FILL;
                            config.label.backgroundColor = Cesium.Color.fromCssColorString(this.controls.labelBackgroundColor.value);
                        } else {
                            config.label.outlineColor = Cesium.Color.BLACK;
                            config.label.outlineWidth = 1;
                            config.label.style = Cesium.LabelStyle.FILL_AND_OUTLINE;
                        }

                        if ( this.controls.distanceDisplayCondition.value ) {
                            config.label.distanceDisplayCondition = new Cesium.DistanceDisplayCondition( this.controls.distanceDisplayConditionRange.from, this.controls.distanceDisplayConditionRange.to );
                        } else {
                            config.label.distanceDisplayCondition = undefined;
                        }

                        if ( this.controls.translucencyByDistance.value ) {
                            config.label.translucencyByDistance = new Cesium.NearFarScalar(
                                this.controls.translucencyByDistanceRange.from, this.controls.translucencyByDistanceRangeOpacityFrom.value, 
                                this.controls.translucencyByDistanceRange.to, this.controls.translucencyByDistanceRangeOpacityTo.value
                            );
                        } else {
                            config.label.translucencyByDistance = undefined;
                        }

                        if ( this.controls.scaleByDistance.value ) {
                            config.label.scaleByDistance = new Cesium.NearFarScalar(
                                this.controls.scaleByDistanceRange.from, this.controls.scaleByDistanceRangeScaleFrom.value, 
                                this.controls.scaleByDistanceRange.to, this.controls.scaleByDistanceRangeScaleTo.value
                            );
                        } else {
                            config.label.scaleByDistance = undefined;
                        }

                        // config.label.eyeOffset = new Cesium.Cartesian3(0, 0, this.controls.labelOffset.value );

                        e = this.services.mapService.viewer.entities.add ( config );
                        if ( e ) {
                            this.labelEntities.push(e);
                        }
                    }
                }
                if ( this.xx == 10 ) {
                    // console.log('@@@@@@@@@@', cartesianPosition, config, e );
                }
            });

            this.entity ( 'labels', this.labelEntities );
        }

        // console.log('##LABELS PROPS', result, this.labelEntities );


        //this.controls.info.value = 'Viewing '+ this.labelEntities.length + ' labels (of '+Object.keys(this.propertyStore.hashed).length+' possible).';
        this.controls.info.translateParams = {viewLength:this.labelEntities.length,possibleLength:Object.keys(this.propertyStore.hashed).length}

    }


    end() {
        // clear old labels
        this.wipe();
        this.stopPulse();

        delete this.propertyStore;
    }

    findAllProps ( props:any, these:string[] = [] ) {

        let res = [];

        if ( props.hashed ) {

            Object.keys(props.hashed).forEach ( hash => {

                let hashed = props.hashed[hash];
                if ( hashed ) {

                    let object = {};

                    these.forEach ( key => {
                        const value = hashed[key];
                        if ( value !== null && value !== 'null' && (''+value).trim() !== '' ) {
                            object[key] = value;
                        }
                    });

                    if ( object && Object.keys(object).length == these.length ) {
                        res.push(object);
                    }
                }
            });
        }

        return res;

    }
}


